import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { getCodeFromItem } from 'components/TreeSelector';

import {
	Form,
	EditNavLink,
	StyledSection as Section,
	MetadataSummary,
	MetadataSummaryLine,
	SummaryLabel,
	SummaryValue,
	FormHeader,
	FormTitle,
	FormDescription,
} from '../styles';

const EDIT_LINK_URL = '/settings/archive/edit/metadata';

export class ExportMetadataSectionBase extends Component {
	static propTypes = {
		exportedMetadata: PropTypes.any,
	};

	render() {
		const { exportedMetadata } = this.props;

		return (
			<Form>
				<FormHeader>
					<FormTitle>Metadata Saved</FormTitle>
					<FormDescription>
						Your Knowledge Base Metadata has been saved.
					</FormDescription>
				</FormHeader>
				<Section animationIndex={1} title="Metadata summary">
					<EditNavLink to={EDIT_LINK_URL}>Edit metadata</EditNavLink>
					<MetadataSummary>
						<MetadataSummaryLine>
							<SummaryLabel>Industry:</SummaryLabel>
							<SummaryValue>
								{get(exportedMetadata, 'industry.data.value')}
							</SummaryValue>
						</MetadataSummaryLine>
						<MetadataSummaryLine>
							<SummaryLabel>Revenue:</SummaryLabel>
							<SummaryValue>
								{get(exportedMetadata, 'revenue.data.value')}
							</SummaryValue>
						</MetadataSummaryLine>
						<MetadataSummaryLine>
							<SummaryLabel>Number of employees:</SummaryLabel>
							<SummaryValue>
								{get(exportedMetadata, 'employeesNumber.data.value')}
							</SummaryValue>
						</MetadataSummaryLine>
						<MetadataSummaryLine>
							<SummaryLabel>Head office location:</SummaryLabel>
							<SummaryValue>
								{get(exportedMetadata, 'headOfficeLocation.data.value')}
							</SummaryValue>
						</MetadataSummaryLine>
						<MetadataSummaryLine>
							<SummaryLabel>Countries operated in:</SummaryLabel>
							<SummaryValue>
								{get(exportedMetadata, 'geographies.data')
									.map(item => getCodeFromItem(item).name)
									.join(', ')}
							</SummaryValue>
						</MetadataSummaryLine>
					</MetadataSummary>
				</Section>
			</Form>
		);
	}
}
